import { z } from "zod";

export const UploadMenuImageResponseSchema = z.object({
  url: z.string().url(),
  key: z.string().min(1),
  bytes: z.number().int().nonnegative(),
  width: z.number().int().positive(),
  height: z.number().int().positive(),
});
export type UploadMenuImageResponse = z.infer<typeof UploadMenuImageResponseSchema>;

export const UploadStoreLogoResponseSchema = z.object({
  url: z.string().url(),
  key: z.string().min(1),
  bytes: z.number().int().nonnegative(),
  width: z.number().int().positive(),
  height: z.number().int().positive(),
});
export type UploadStoreLogoResponse = z.infer<typeof UploadStoreLogoResponseSchema>;
